var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 8,
    viewBox: "-1 -1 17 9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "1.5px",
    x2: 7,
    y2: 7,
    transform: "translate(0.326)"
  }), /*#__PURE__*/React.createElement("line", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "1.5px",
    x1: 7,
    y2: 7,
    transform: "translate(7.326)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDropdown);
export default __webpack_public_path__ + "static/media/arrow_dropdown.2f4f3897287ab12db4f73112a436a35c.svg";
export { ForwardRef as ReactComponent };